module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web1.5579e8e5.png";